import React, { Component } from "react";
import { Box } from "@mui/material";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import settings from "../helpers/settings";
import axios from "axios";
import Cookies from "js-cookie";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import codes from "./../helpers/countryCodes";
import Select from "react-select";

let { KayanURL } = settings;

class UpdatePatient extends Component {
  constructor(props) {
    super(props);
    let countryCodes = [];
    Object.keys(codes).map((key) => {
      countryCodes.push({ value: codes[key], label: key });
    });
    this.state = {
      firstName: this.props.selectedPatient[0].firstName,
      lastName: this.props.selectedPatient[0].lastName,
      identifier: this.props.selectedPatient[0].identifier,
      profileId: this.props.selectedPatient[0].profileId,
      gender: this.props.selectedPatient[0].gender,
      birthDate: this.props.selectedPatient[0].birthDate,
      phone: this.props.selectedPatient[0].phone,
      identifierType: this.props.selectedPatient[0].identifierType,
      country: this.props.selectedPatient[0].country,
      countryCodes: countryCodes,
      defaultCountry: {
        value: this.props.selectedPatient[0].country,
        label: Object.keys(codes).find(
          (key) => codes[key] === this.props.selectedPatient[0].country
        ), //codes[this.props.selectedPatient[0].country],
      },
    };
    console.log(this.state.defaultCountry, "<<<<<<<<<<<<<");
  }
  componentDidMount = async () => { };

  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };
  HandleInputTextChangeCountry = (e) => {
    let value = e.value;
    this.setState({ ["country"]: value });
  };

  handleUpdate = async (e) => {
    e.preventDefault();
    this.setState({ requestSent: true, response: false, error: "" });
    let patient = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      identifier: this.state.identifier,
      profile_id: this.state.profileId,
      gender: this.state.gender,
      birthdate: this.state.birthDate,
      phone: this.state.phone,
      identifier_type: this.state.identifierType,
      country: this.state.country,
    };
    let updatePatient = await axios.put(
      KayanURL + "/test/patients/updatePatient",
      {
        patient: patient,
        patient_id: this.props.selectedPatient[0].patientId,
        apiToken: Cookies.get("id"),
      }
    );
    if (updatePatient) {
      this.setState({ requestSent: false, response: true });
      let { data } = updatePatient;
      if (data) {
        if (data.success) {
          this.setState({ success: true });
          this.props.backToPatientScreen();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };

  render() {
    return (
      <>
        <Box height={60} />
        <div>
          <div style={{ width: "95%", margin: "auto", padding: "20px" }}>
            <FormControl style={{ width: "100%" }}>
              <Container>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Profile Id *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="profileId"
                        onChange={this.HandleInputTextChange}
                        required
                        readOnly
                        defaultValue={this.props.selectedPatient[0].profileId}
                        placeholder=" Enter Profile Id"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        First Name *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        required
                        onChange={this.HandleInputTextChange}
                        placeholder="Enter First Name"
                        defaultValue={this.props.selectedPatient[0].firstName}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Birthdate *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="birthDate"
                        onChange={this.HandleInputTextChange}
                        required
                        placeholder={this.props.selectedPatient[0].birthDate}
                        onFocus={(e) => (e.target.type = "date")}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Identifier Type *
                      </Form.Label>
                      <Form.Select
                        onChange={this.HandleInputTextChange}
                        required
                        name="identifierType"
                        defaultValue={
                          this.props.selectedPatient[0].identifierType
                        }
                      >
                        <option value="0">select...</option>
                        <option value="NI">National Identifier</option>
                        <option value="PPN">Passport Number</option>
                        <option value="BCT">Birth Certificate</option>
                        <option value="MR">Medical Record</option>
                        <option value="memberid">Member ID</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Last Name *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        onChange={this.HandleInputTextChange}
                        required
                        placeholder="Enter Last Name"
                        defaultValue={this.props.selectedPatient[0].lastName}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Identifier *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="identifier"
                        onChange={this.HandleInputTextChange}
                        required
                        placeholder="Enter Identifier Number"
                        defaultValue={this.props.selectedPatient[0].identifier}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Phone{" "}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        required
                        onChange={this.HandleInputTextChange}
                        placeholder="Enter Phone"
                        defaultValue={this.props.selectedPatient[0].phone}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Country *
                      </Form.Label>
                      <Select
                        className="mb-3"
                        onChange={this.HandleInputTextChangeCountry}
                        options={this.state.countryCodes}
                        isSearchable="true"
                        defaultValue={this.state.defaultCountry}
                        // value={selectedValue}
                        required
                      ></Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontSize: "13px" }}>
                        Gender *
                      </Form.Label>
                      <Form.Select
                        onChange={this.HandleInputTextChange}
                        required
                        name="gender"
                        defaultValue={this.props.selectedPatient[0].gender}
                      >
                        <option value="0">select...</option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <div>
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={(e) => this.handleUpdate(e)}
                    style={{
                      width: "15%",
                      marginTop: "32px",
                      backgroundColor: "rgb(78 75 75)",
                      border: "1px solid rgb(78 75 75)",
                    }}
                  >
                    Update
                  </Button>
                </div>
              </Container>
            </FormControl>
          </div>
          {this.state.requestSent && !this.state.registrationResponse ? (
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Spinner animation="border" variant="success" />
            </div>
          ) : this.state.registrationResponse && this.state.error ? (
            <h5 style={{ color: "red", textAlign: "center" }}>
              {this.state.error}
            </h5>
          ) : null}

          <div style={{ width: "50%", marginright: "auto", textAlign: "left" }}>
            <Button
              variant="primary"
              type="submit"
              onClick={() => this.props.backToPatientScreen()}
              style={{
                width: "10%",
                marginTop: "32px",
                padding: "3px 6px",
                backgroundColor: "rgb(78 75 75)",
                border: "1px solid rgb(78 75 75)",
              }}
            >
              <ArrowBackIcon />
            </Button>
          </div>
        </div>
      </>
    );
  }
}
export default UpdatePatient;
